module.exports = __webpack_public_path__ + "static/media/chevron-forward-white.9dcfe5aa.svg";